import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export const listReportUnsubmitted = async (params: any = {}) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/CatchReport/report-unsubmitted${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
